import { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../../core/component/layout';

// Import the tab components
import AgentsTab from './AgentMgtTabs/AgentsTab';
import KnowledgeBaseTab from './AgentMgtTabs/KnowledgeBaseTab';
import CategoriesTab from './AgentMgtTabs/CategoriesTab';
import DepartmentsRolesTab from './AgentMgtTabs/DepartmentsRolesTab';

const AgentManagement = () => {
    const [activeTab, setActiveTab] = useState('agents');


    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"/core/dashboard"}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"/core/customer-obsession/agents"}>Agent Management</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-header">
                            <ul className="nav nav-tabs profile-tabs" id="agentMgtTabs" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <a
                                        className={`nav-link ${activeTab === 'agents' ? 'active' : ''}`}
                                        id="agents-tab"
                                        data-bs-toggle="tab"
                                        href="#agents"
                                        role="tab"
                                        aria-controls="agents"
                                        aria-selected={activeTab === 'agents'}
                                        onClick={() => setActiveTab('agents')}
                                    >
                                        <i className="ti ti-users me-2"></i>
                                        Agents
                                    </a>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <a
                                        className={`nav-link ${activeTab === 'knowledge-base' ? 'active' : ''}`}
                                        id="knowledge-base-tab"
                                        data-bs-toggle="tab"
                                        href="#knowledge-base"
                                        role="tab"
                                        aria-controls="knowledge-base"
                                        aria-selected={activeTab === 'knowledge-base'}
                                        onClick={() => setActiveTab('knowledge-base')}
                                    >
                                        <i className="ti ti-book me-2"></i>
                                        Knowledge Base
                                    </a>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <a
                                        className={`nav-link ${activeTab === 'categories' ? 'active' : ''}`}
                                        id="categories-tab"
                                        data-bs-toggle="tab"
                                        href="#categories"
                                        role="tab"
                                        aria-controls="categories"
                                        aria-selected={activeTab === 'categories'}
                                        onClick={() => setActiveTab('categories')}
                                    >
                                        <i className="ti ti-tag me-2"></i>
                                        Categories
                                    </a>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <a
                                        className={`nav-link ${activeTab === 'departments-roles' ? 'active' : ''}`}
                                        id="departments-roles-tab"
                                        data-bs-toggle="tab"
                                        href="#departments-roles"
                                        role="tab"
                                        aria-controls="departments-roles"
                                        aria-selected={activeTab === 'departments-roles'}
                                        onClick={() => setActiveTab('departments-roles')}
                                    >
                                        <i className="ti ti-building me-2"></i>
                                        Departments & Roles
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="card-body">
                            <div className="tab-content" id="agentMgtTabContent">
                                <div
                                    className={`tab-pane fade ${activeTab === 'agents' ? 'show active' : ''}`}
                                    id="agents"
                                    role="tabpanel"
                                    aria-labelledby="agents-tab"
                                >
                                    <AgentsTab />
                                </div>
                                <div
                                    className={`tab-pane fade ${activeTab === 'knowledge-base' ? 'show active' : ''}`}
                                    id="knowledge-base"
                                    role="tabpanel"
                                    aria-labelledby="knowledge-base-tab"
                                >
                                    <KnowledgeBaseTab />
                                </div>
                                <div
                                    className={`tab-pane fade ${activeTab === 'categories' ? 'show active' : ''}`}
                                    id="categories"
                                    role="tabpanel"
                                    aria-labelledby="categories-tab"
                                >
                                    <CategoriesTab />
                                </div>
                                <div
                                    className={`tab-pane fade ${activeTab === 'departments-roles' ? 'show active' : ''}`}
                                    id="departments-roles"
                                    role="tabpanel"
                                    aria-labelledby="departments-roles-tab"
                                >
                                    <DepartmentsRolesTab />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default AgentManagement;